import { render, staticRenderFns } from "./uploadMetadata.vue?vue&type=template&id=73f25756&scoped=true"
import script from "./uploadMetadata.vue?vue&type=script&lang=js"
export * from "./uploadMetadata.vue?vue&type=script&lang=js"
import style0 from "./uploadMetadata.vue?vue&type=style&index=0&id=73f25756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f25756",
  null
  
)

export default component.exports